import { Component, OnInit } from '@angular/core';
import { Area } from 'src/app/_models/area.model';
import { AreaService } from 'src/app/_services/area.service';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { baseUrl, environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { CityService } from 'src/app/_services/city.service';
import { map, mergeMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { sortTable } from 'src/app/helpers/sort-table';
@Component({
  selector: 'app-areas-list',
  templateUrl: './areas-list.component.html',
  styleUrls: ['./areas-list.component.scss'],
})
export class AreasListComponent implements OnInit {
  pageTitle: string = 'Areas';
  placeholder: string = "Search by area name …";
  areas: Area[] = [];
  filteredAreas: Area[] = [];
  invertSort: boolean = false;
  theadArray = [
    'Area Arabic Name',
    'Area English Name',
    'City Name',
    'Area Active',
    'Edit Area'
  ];

  constructor(
    private areaService: AreaService,
    private cityService: CityService,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const cityId = this.activatedRoute.snapshot.params.cityId;

    if (cityId) {
      this.getAreasByCityId(cityId);
    } else {
      this.getAllAreas();
    }
  }

  getAreasByCityId(id) {
    this.areaService.getAreasByCityId(id).subscribe((res) => {
      res?.data?.areas.map((area: Area) => {
        this.areas.push(area);
      });
    });
  }

  getAllAreas() {
    let citiesResponse = this.cityService.getAllCities();
    let areasResponse = this.areaService.getAllAreas();

    forkJoin([citiesResponse, areasResponse]).subscribe((result) => {
      let city;

      result[1]?.data?.areas.map((area: Area) => {
        city = result[0].find((item) => item.id === area.cityId);

        if (!!city?.enName) {
          area.cityName = city.enName;
        } else {
          area.cityName = '';
        }

        this.areas.push(area);
      });

      this.filteredAreas = [...this.areas];
    });
  }

  onSearchArea(searchString) {
    this.areaService.searchByName(searchString).subscribe((response) => {
      this.filteredAreas = response['data'];
    })
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredAreas = [...this.areas];
    }
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredAreas = sortTable(
      this.filteredAreas,
      'name',
      this.invertSort
    );
  }

  onAreaActiveChange(event, area) {
    area.isActive = event.target.checked;

    this.areaService.updateArea(area).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.enName} area has been ${response.data.isActive ? 'Activated' : 'Deactivated'}`,
        this.toastr
      );
    });
  }
}
